import { Handle, Position } from '@xyflow/react';
import useAutomationsStore from '../../../../../store/useAutomationsStore';

export default function BaseNode({
  id,
  selected,
  color,
  icon: Icon,
  image,
  label,
  children,
  hasInput = true,
  hasOutput = true,
  outputHandles,
  headerExtra,
}) {
  const simulatingNodes = useAutomationsStore((s) => s.simulatingNodes);
  const isRunning = simulatingNodes.has(id);

  return (
    <div
      className={[
        'bg-white rounded-xl shadow-sm border-2 min-w-[200px] max-w-[260px] transition-all duration-300',
        selected ? 'shadow-md' : '',
        isRunning ? 'ring-4 ring-offset-1 scale-[1.03]' : '',
      ].join(' ')}
      style={{
        borderColor: isRunning ? color : selected ? color : '#e5e7eb',
        ringColor: isRunning ? color : undefined,
        '--tw-ring-color': isRunning ? color + '55' : undefined,
      }}
    >
      {hasInput && (
        <Handle
          type="target"
          position={Position.Top}
          className="!w-3 !h-3 !border-2 !border-white"
          style={{ backgroundColor: color }}
        />
      )}

      <div
        className="flex items-center gap-2 px-3 py-2 rounded-t-[10px]"
        style={{ backgroundColor: color }}
      >
        {image ? (
          <img src={image} alt={label} className="w-4 h-4 object-contain rounded" />
        ) : Icon ? (
          <Icon className="w-4 h-4 text-white" />
        ) : null}
        <span className="text-sm font-semibold text-white truncate flex-1">{label}</span>
        {headerExtra}
      </div>

      <div className="px-3 py-2">{children}</div>

      {outputHandles ? (
        outputHandles
      ) : hasOutput ? (
        <Handle
          type="source"
          position={Position.Bottom}
          className="!w-3 !h-3 !border-2 !border-white"
          style={{ backgroundColor: color }}
        />
      ) : null}
    </div>
  );
}
